/**
 * Browser entry point for the landing application.
 *
 * Mounts the React application into the DOM and registers the
 * service worker for PWA installability. This file is the Vite
 * entry referenced by index.html.
 *
 * @module landing/main
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registerServiceWorker } from '../../shared/src/pwa/service-worker';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html contains <div id="root"></div>.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

void registerServiceWorker(import.meta.env.BASE_URL + 'service-worker.js');
